/** @file Locates a time among timeline keys: bracketing key indices and the normalized segment time. */
import { findSegment } from '../../curve/findSegment';

/** Caller-owned cursor: k0/k1 bracket the time (equal when clamped to the first or last key); u in [0, 1). */
export interface KeyCursor {
  k0: number;
  k1: number;
  u: number;
}

/** Fills cur for time (before the first key: key 0; at or after the last: the last key); false without keys. */
export function locateKey(times: Float64Array, time: number, cur: KeyCursor): boolean {
  const n = times.length;
  if (n === 0) return false;
  const i = findSegment(times, time);
  if (i < 0 || i >= n - 1) {
    const k = i < 0 ? 0 : n - 1;
    cur.k0 = k;
    cur.k1 = k;
    cur.u = 0;
    return true;
  }
  const t0 = times[i] ?? 0;
  const t1 = times[i + 1] ?? t0;
  cur.k0 = i;
  cur.k1 = i + 1;
  cur.u = t1 > t0 ? (time - t0) / (t1 - t0) : 0;
  return true;
}
